import { create } from 'zustand';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

interface Ask { title: string; description?: string; confirmLabel?: string; destructive?: boolean }
interface State { ask: (Ask & { resolve: (ok: boolean) => void }) | null; open: (a: Ask) => Promise<boolean>; answer: (ok: boolean) => void }

const useConfirmStore = create<State>((set, get) => ({
  ask: null,
  open: (a) => new Promise<boolean>(resolve => {
    get().ask?.resolve(false); // yêu cầu cũ chưa trả lời coi như huỷ
    set({ ask: { ...a, resolve } });
  }),
  answer: (ok) => { get().ask?.resolve(ok); set({ ask: null }); }
}));

/** Thay cho window.confirm: hộp xác nhận trong ứng dụng (không bị trình duyệt nhúng/chặn popup nuốt mất). */
export const confirmAsk = (a: Ask): Promise<boolean> => useConfirmStore.getState().open(a);

/** Gắn MỘT lần ở gốc ứng dụng. */
export function ConfirmHost() {
  const ask = useConfirmStore(s => s.ask);
  const answer = useConfirmStore(s => s.answer);
  return (
    <Dialog open={!!ask} onOpenChange={(o) => !o && answer(false)}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{ask?.title}</DialogTitle>
          {ask?.description && <DialogDescription>{ask.description}</DialogDescription>}
        </DialogHeader>
        <DialogFooter className="gap-2 sm:gap-2">
          <Button variant="outline" onClick={() => answer(false)}>Huỷ</Button>
          <Button variant={ask?.destructive === false ? 'default' : 'destructive'} onClick={() => answer(true)} autoFocus>{ask?.confirmLabel ?? 'Xoá'}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
